import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { showAlert } from 'actions/client';
import { createVenue, fetchManagedPages } from 'actions/venue';
import ComboInputField from 'components/FormElements/ComboInputField';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import FormTextField from 'components/FormElements/FormTextField';
import LinkToPageTooltip from 'components/Utility/TooltipModal/LinkToPageTooltip';
import React from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, isValid, reduxForm } from 'redux-form';
import { Required } from 'utils/validators';
import './index.scss';

class CreateVenuePanel extends React.Component {
  state = {
    cloneStripe: false,
    cloneMenu: false,
  };

  // Lifecycle

  componentWillMount() {
    this.fetchFatsomaManagedPages();
  }

  componentWillUpdate(nextProps, nextState) {
    if (!nextProps.creatingVenue && this.props.creatingVenue) {
      if (nextProps.venueCreated) {
        this.showVenueCreated();
      } else {
        this.showVenueError();
      }
    }
  }

  fetchFatsomaManagedPages(data = {}) {
    if (!this.props.fatsomaPageConnected) {
      this.props.fetchManagedPages(data);
    }
  }

  queryFatsomaManagedPages(query) {
    if (!query || query.length < 2) {
      return;
    }

    if (this.props.managedPagesQueryable) {
      this.fetchFatsomaManagedPages({ query });
    }
  }

  render() {
    return (
      <div className="panel__content create__venue__container">
        <h3 className="panel__title">Create Venue</h3>
        <div className="panel__container">
          <p className="panel__description">
            You can create a new venue or clone an existing venue here.
          </p>

          <form
            autoComplete="off"
            autoCorrect="off"
            spellCheck="off"
            className="panel__form"
          >
            <input type="hidden" value="prayer" />

            <Field
              className="panel__input"
              autoCorrect="off"
              spellCheck="off"
              autoComplete="off"
              name="name"
              type="name"
              margin="normal"
              placeholder="My Venue"
              component={FormTextField}
              validate={[Required]}
              label="Venue Name"
              style={{ marginBottom: 20 }}
            />

            <Field
              name="fatsoma_page_id"
              label="Link with Fatsoma Page"
              labelEndAdornment={<LinkToPageTooltip />}
              fullWidth
              component={ComboInputField}
              items={this.props.managedPages}
              isLoading={this.props.fetchingManagedPages}
              noItemsMessage="Setup your Fatsoma page first."
              onInputEdit={v => this.queryFatsomaManagedPages(v)}
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="cloneStripe"
                  checked={this.state.cloneStripe}
                  onChange={(event, checked) =>
                    this.setState({ cloneStripe: checked })
                  }
                />
              }
              label="Copy Bank Information"
              style={{ marginTop: 20 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="cloneMenu"
                  checked={this.state.cloneMenu}
                  onChange={(event, checked) =>
                    this.setState({ cloneMenu: this.state.cloneMenu })
                  }
                />
              }
              label="Copy Menus"
              style={{ marginTop: 20, display: 'none' }}
            />

            <FormSubmitButton
              disabled={!this.props.isFormValid}
              onClick={this.submit}
              className="panel__form__submit__btn"
              loading={this.props.creatingVenue}
            >
              Create
            </FormSubmitButton>
          </form>
        </div>
      </div>
    );
  }

  // Alerts

  showVenueCreated = () => {
    this.props.showAlert(
      'Venue Created',
      'You have successfully created a new venue.'
    );
  };

  showVenueError = () => {
    this.props.showAlert(
      'Something went wrong',
      "We couldn't create the new venue."
    );
  };

  // Form Actions

  submit = () => {
    if (!this.props.isFormValid) {
      this.props.showAlert(
        'Form Error',
        'You have not entered all required details. Please ensure all fields are filled and try again.'
      );
      return;
    }

    const formValues = this.props.formValues;

    formValues['cloneStripe'] = this.state.cloneStripe;
    formValues['cloneMenu'] = this.state.cloneMenu;

    formValues['owner'] = this.props.venue.owner;
    this.props.createVenue(formValues);
  };
}

const mapStateToProps = state => ({
  formValues: getFormValues('create-venue')(state) || {},
  isFormValid: isValid('create-venue')(state) || false,
  venue: state.venue,
  creatingVenue: state.venue.creatingVenue,
  venueCreated: state.venue.venueCreated,
  fetchingManagedPages: state.venue.fetchingManagedPages,
  managedPages: state.venue.managedPages,
  managedPagesQueryable: state.venue.managedPagesQueryable,
  initialValues: {
    name: '',
    cloneStripe: false,
    cloneMenu: false,
  },
});

const mapDispatchToProps = dispatch => ({
  createVenue: data => dispatch(createVenue(data)),
  showAlert: (title, message) => dispatch(showAlert(title, message)),
  fetchManagedPages: data => dispatch(fetchManagedPages(data)),
});

CreateVenuePanel = reduxForm({
  form: 'create-venue',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(CreateVenuePanel);

export default connect(mapStateToProps, mapDispatchToProps)(CreateVenuePanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/CreateVenue/index.jsx